import React from 'react';
import styles from './CorrectionCard.module.css';
import type { ForemanCorrection } from '../../types/foreman';

interface CorrectionCardProps {
  correction: ForemanCorrection;
}

const CorrectionCard: React.FC<CorrectionCardProps> = ({ correction }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.icon}>{'\u270E'}</span>
        <span className={styles.headerLabel}>Correction Recorded</span>
      </div>

      <div className={styles.field}>{correction.field}</div>

      <div className={styles.diff}>
        <span className={styles.original}>{correction.original}</span>
        <span className={styles.arrow}>{'\u2192'}</span>
        <span className={styles.corrected}>{correction.corrected}</span>
      </div>

      <div className={styles.meta}>
        {correction.context && (
          <span className={styles.metaItem}>
            <span className={styles.metaLabel}>Context:</span>
            {correction.context}
          </span>
        )}
        {correction.corrected_by && (
          <span className={styles.metaItem}>
            <span className={styles.metaLabel}>By:</span>
            {correction.corrected_by}
          </span>
        )}
      </div>
    </div>
  );
};

export default CorrectionCard;
